// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3aroO","info":"UpdateTermsInfo_info__2vQGD"};